<template>
    <div class="container">
        <div class="main">
            
        </div>
    </div>
</template>

<script>
export default {
    props:{
        modelList:Array
    },
    methods: {
        handleDelete(index, row) {
            console.log(index, row);
        }
    }
}
</script>

<style scoped lang="less">
.container{
    width: 100%;
    .main {
        height: 100%;
    }
}

</style>